export const IHEALTH_INQUIRING_PROVIDER_OPTION = {
  label: 'iHealth Labs',
  value: '1710514476'
};
